import { render, staticRenderFns } from "./InsureProductItem.vue?vue&type=template&id=621d510f&scoped=true&"
import script from "./InsureProductItem.vue?vue&type=script&lang=js&"
export * from "./InsureProductItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621d510f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('621d510f')) {
      api.createRecord('621d510f', component.options)
    } else {
      api.reload('621d510f', component.options)
    }
    module.hot.accept("./InsureProductItem.vue?vue&type=template&id=621d510f&scoped=true&", function () {
      api.rerender('621d510f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "meibao-insure/src/components/InsureProductItem.vue"
export default component.exports